export enum EMarital {
  SINGLE = 'single',
  MARRIED = 'married',
  DIVORCED = 'divorced',
}
